import {loadImageFromVideo, isVideo, isImage} from "@/util/video_utils_v2";
import typeText from "../types/text";
import SuggestionList from "../SuggestionList";
import {mapState} from "vuex";

export default {
  name: "UploadGallery",
  props: {
    onSendFiles: {
      type: Function,
      default: () => {}
    },
    selectedChat: {
      type: Object,
      default: () => {}
    },
    selectedChatId: {
      type: String,
      default: ""
    }
  },
  components: {
    typeText,
    SuggestionList
  },
  data() {
    return {
      show: false,
      files: [],
      showSuggestion: false,
      currentWord: "",
      sendingFile: false,
      selectedFile: 0,
      currentTextSelected: {text: ""}
    }
  },
  computed: {
    ...mapState({
      //
    }),
    selectedItem() {
      if (this.selectedFile >= 0) {
        return this.files[this.selectedFile];
      }
      return null;
    }
  },
  watch: {
    selectedFile(newVal) {
      if (newVal >= 0 && this.files[newVal]) {
        this.currentTextSelected.text = this.$refs.textEditor.$refs.textEditor.innerHTML = this.files[newVal].text;
      } else {
        this.currentTextSelected.text = this.$refs.textEditor.$refs.textEditor.innerText = "";
      }
    },
  },
  methods: {
    onOverlayDragLeave(event) {
      const overlay = event.currentTarget;
      const related = event.relatedTarget;
      if (this.files.length === 0 && (!related || !overlay.contains(related))) {
        this.show = false;
      }
    },
    async onDragEnd(event) {
      event.preventDefault();
      event.stopPropagation();

      for(const file of event.dataTransfer.files) {
        this.addFile(file, await this.loadFileResource(file));
      }

      return false;
    },
    async onAddedFiles(event) {
      event.preventDefault();
      event.stopPropagation();

      for(const file of event.target.files) {
        try {
          const resource = await this.loadFileResource(file);
          this.addFile(file, resource);
        } catch(error) {
          console.error(error);
        }
      }

      const input = this.$refs.fileUpload;
      input.value = '';
      if (!/safari/i.test(navigator.userAgent)) {
        input.type = '';
        input.type = 'file'
      }

      return false;
    },
    loadFileResource(file) {
      return new Promise((resolve) => {
        let URLObj = window.URL || window.webkitURL;
        let source = URLObj.createObjectURL(file);
        resolve(source);
      });
    },
    async addFile(file, blob) {
      const fileTmp = {
        url: file.name
      };
      const isVid = isVideo(fileTmp);
      const isImg = isImage(fileTmp);

      this.files.push({
        chat_id: this.selectedChatId,
        type: "media",
        file_type: "doc",
        file_type_ext: isVid ? "video" : (isImg ? "image" : "doc"),
        text: "",
        file: file,
        url: isVid ? await loadImageFromVideo(blob) : blob,
        videoSrc: isVid ? blob : null
      });

      this.selectedFile = this.files.length - 1;
      this.focusCaptionField();
    },
    isImage(file) {
      const fileTmp = {
        url: file.url
      };
      return isImage(fileTmp);
    },
    isVideo(file) {
      const fileTmp = {
        url: file.url
      };
      return isVideo(fileTmp);
    },
    showModal() {
      this.show = true;
      this.files = [];
      this.focusCaptionField();
    },
    hideModal() {
      this.show = false;
      this.files = [];
    },
    focusCaptionField() {
      this.$nextTick(() => {
        if (this.$refs.textEditor && typeof this.$refs.textEditor.focus === 'function') {
          this.$refs.textEditor.focus();
        }
      });
    },
    onKeyDown(event) {
      if (event.key === 'Escape' && this.show) {
        this.hideModal();
      }
    },
    send() {
      this.onSendFiles(this.files);
    },
    findContactSuggestion(search, showSuggestion) {
      if (showSuggestion) {
        this.showSuggestion = true;
        this.currentWord = search;
      } else {
        this.showSuggestion = false;
        this.currentWord = "";
      }
    },
    selectSuggestionContact(user) {
      const name = `${user.first_name} ${user.last_name}`;
      this.$refs.textEditor.selectSuggestion(name);
    },
    setter() {
      if (this.selectedFile >= 0 && this.files[this.selectedFile]) {
        this.files[this.selectedFile].text = this.$refs.textEditor.getTextWithSuggestionsBolded();
      }
    },
    deleteFile(index) {
      this.files.splice(index, 1);
      if (this.files.length === 0) {
        this.hideModal();
      } else if (this.selectedFile >= this.files.length) {
        this.selectedFile = this.files.length - 1;
      }
    },
    sendFiles() {
      if (this.files.length === 0) return;
      this.onSendFiles(this.files);
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  }
}
